export const gitVersion = {
  "tag": "5.5.10",
  "commit": "bc28bd532d0adfc061a50e647c5fd08f8f7610d8",
  "branch": "main"
}